import { render, staticRenderFns } from "./tickets-tab.vue?vue&type=template&id=aa3a8ec8&scoped=true&"
import script from "./tickets-tab.vue?vue&type=script&lang=js&"
export * from "./tickets-tab.vue?vue&type=script&lang=js&"
import style0 from "./tickets-tab.vue?vue&type=style&index=0&id=aa3a8ec8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3a8ec8",
  null
  
)

export default component.exports